import React from 'react';
import {ListGroup, ListGroupItem} from 'reactstrap'

export default function CommuniqueShow(props) {

    const {communique} = props;
    return (
        <div className="row">
            <div className="col-md-3">
                <img src={communique.cover_url} className="w-100" alt={communique.name}/>
            </div>
            <div className="col-md-9">
                <div className="row no-gutters">
                    {
                        ((communique.communique_evaluation || {}).communique_questions || []).map((question, i) => [
                                <div className="col-lg-6 col-12">
                                    <div className="card m-1">
                                        <div className="card-block">
                                            <h5 className="card-title mb-0">
                                                {question.question}
                                            </h5>
                                        </div>
                                        <ListGroup className="list-group list-group-flush">
                                            {
                                                question.communique_answers.map((answer, i) => (
                                                    <ListGroupItem key={answer.id} active={answer.points > 0 ? true : null}>
                                                        <i className={answer.points === 0 ? "fa fa-fw fa-circle-o" : "fa fa-fw fa-check"}></i>
                                                        {answer.answer}
                                                    </ListGroupItem>
                                                ))
                                            }
                                        </ListGroup>
                                    </div>
                                </div>,
                                (i+1) % 2 === 0 ? <div className="clearfix hidden-md-down"></div> : null
                            ]
                        )
                    }
                </div>
            </div>
        </div>
    );

}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/communiques/CommuniqueShow.jsx
 **/